<template>
  <div>
    <div v-for="(item,index) in fileList" :key="index">
      <el-link type="primary" @click="showDetail(item.netUrl)">{{item.fileName}}</el-link><el-button v-if="item.fileType !=='zip' && item.fileType !=='rar'&& item.fileType !=='docx'&& item.fileType !=='doc' && item.fileType !=='xlsx'" style="margin-left: 10px"   type="text" @click="preview(item)">预览</el-button>
    </div>
    <el-dialog :title="previewList.fileName" :visible.sync="previewDialog" width="1080px" append-to-body>
      <div style="height: 600px">
        <iframe :src="previewList.netUrl" frameborder="0" ref="previewFile" style="height: 100%;width: 100%;"></iframe>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { listByGuidsStr } from '@@/api/login'

export default {
  props: {
    fileId: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      fileList: [],
      previewDialog: false,
      previewList:{}
    };
  },
  created() {
    this.getFileList();
  },
  watch:{
    fileId(newValue,oldValue){
      if (oldValue != newValue){
        this.getFileList();
      }
    },
  },
  methods: {
    getFileList(){
      if (this.fileId != ''){
        listByGuidsStr(this.fileId).then(response => {
          this.fileList = response.data;
        });
      }
    },
    // 新窗口打开文件
    showDetail(url){
      window.open(url);
    },
    preview(val){
      this.previewList = val
      this.previewDialog = true
    },
  }
}
</script>
